import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadDraft,
  selectApplication,
  selectAppLoading,
  selectAppError
} from '../../redux/slices/applicationSlice';
import ApplicantLayout from '../../layouts/applicantLayout';
import './index.scss';

// Fetches the applicant's draft before rendering any step.
// Every step can then assume `application` exists.
const WizardGate = () => {
  const dispatch = useDispatch();
  const application = useSelector(selectApplication);
  const loading = useSelector(selectAppLoading);
  const error = useSelector(selectAppError);

  useEffect(() => {
    if (!application) dispatch(loadDraft());
  }, [dispatch, application]);

  if (loading && !application) {
    return (
      <div className="wizard-gate">
        <div className="wizard-gate__spinner" aria-hidden="true" />
        <p className="wizard-gate__text">Loading your application…</p>
      </div>
    );
  }

  if (error && !application) {
    return (
      <div className="wizard-gate">
        <h2 className="wizard-gate__title">We couldn’t load your application</h2>
        <p className="wizard-gate__text">{error}</p>
        <button type="button" className="wizard-gate__retry" onClick={() => dispatch(loadDraft())}>
          Try again
        </button>
      </div>
    );
  }

  if (!application) return null;

  return <ApplicantLayout />;
};

export default WizardGate;
